const prefix = 'phone-2.0';

const components = {
  voicemail: 'voicemail',
  recentCalls: 'recent-calls',
};

export const trackingId = ({ component, context }: { component: keyof typeof components; context: string }) => {
  return `${prefix}::${components[component]}::${context}`;
};

export const recentCallsTrackingId = ({ context }: { context: string }) => {
  return trackingId({ component: 'recentCalls', context });
};
